<template>
    <div>
        <!--<a href="" class="mb-2 btn bg-arielle-smile btn-lg btn-block font-weight-bold">
            <img src="/assets/images/fb.png" style="display: inline">
            Sign up or Login with Facebook
        </a>
        <div class="login-hr"></div>-->
        <div class="loginMessage text-center">Enter your mobile no</div>
        <form action="" method="post" class="mt-2">
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text">+88</span>
                </div>
                <input placeholder="01XXXXXXXXX"
                       type="text"
                       class="form-control"
                       v-model="formData.email_phone_number"
                />
            </div>
            <span class="text-danger">
                {{ $errorMessage(errors, 'email_phone_number') }}
            </span>
            <div class="loginMessage text-center mt-2">Enter your password</div>
            <input type="password"
                   class="form-control mt-2"
                   placeholder="Enter your password"
                   v-model="formData.password"
            />
            <span class="text-danger">
                {{ $errorMessage(errors, 'password') }}
            </span>
            <div class="mt-3 pb-0">
                <button type="button"
                        class="btn btn-danger btn-lg btn-block"
                        :disabled="loading"
                        @click="submitLogin">LOGIN</button>
                <p class="text-center mt-1">
                    Don't have account? <a href="/user/sign-up?redirect=checkout" >Sign up</a>
                </p>
            </div>
        </form>
    </div>
</template>

<script>
    export default {
        name: "Login",
        data() {
            return {
                loading: false,
                errors: {},
                formData: {},
            }
        },
        methods: {
            submitLogin() {
                this.loading = true;
                window
                    .axios
                    .post(`/admin/users/login`, this.formData)
                    .then(response => {
                        console.log(response)
                        window.location = '/checkout';
                    })
                    .catch(({response}) => {
                        this.errors = response.data.errors;
                        if (Number(response.status) !== 422) {
                            this.$toastr.e(response.data.message || response.statusText)
                        }
                        this.loading = false;
                    })
            }
        },
    }
</script>

<style scoped>

</style>